import {scrollFrame} from "../../setup/js/_scrollFrame.2";

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};
$(document).on("tqht_mansite_header rendered", {}, function (event, uniqueId) {
    var $this = $("#" + uniqueId);

  

    // function observe() {
    //     const observer = new IntersectionObserver((entries) => {
    //         entries.forEach(entry => {
    //             if (entry.intersectionRatio >= 0.7) {
    //                 const elTarget = $(entry.target);
    //                 if (!elTarget.hasClass('viewing')) {
    //                     $('#wrapper section').add('#float_left ul li a').removeClass('viewing active');
    //                     elTarget.addClass('viewing');
    //                     const elNavTarget = $('#float_left').find(`a[href="#${elTarget.attr('id')}"]`);
    //                     elNavTarget.addClass('active');

    //                     currentFrame(elTarget);
    //                 };
    //             }
    //         });
    //     }, {
    //         threshold: [0, 0.7, 1]
    //     });

    //     const targetElements = document.querySelectorAll('.tqht_mansite_header,.frame2,.frame3,.frame4,.frame5');
    //     targetElements.forEach(element => observer.observe(element));

    // }
    // observe();



  
    
    if (window.innerWidth > 768) {
// Lấy phần hash trong URL, ví dụ: #tqht_mansite_news_event
const hash = window.location.hash;

// Kiểm tra nếu có hash trong URL
if (hash) {
    const queryName = hash.substring(1); // Lấy phần tử sau dấu '#'

    // Kiểm tra nếu phần tử có class này tồn tại và thêm class active
    if ($('.' + queryName).length) {
        $('.' + queryName).addClass('active');
        if (queryName === 'tqht_mansite_header') {
            $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").removeClass("active");
        } else {
            $(".floatleft__main, .container_floatright, .floatright_nap, .floatright_download, .floatright_nhapcode, .floatright_hotro").addClass("active");
        }
    } else {
        // Nếu không tìm thấy phần tử tương ứng với hash, có thể thêm thông báo lỗi hoặc xử lý theo cách khác
        console.log("Không tìm thấy phần tử với class: " + queryName);
    }
} else {
    // Nếu không có hash trong URL, không làm gì hoặc có thể thêm hành động khác.
    console.log("Không có hash trong URL.");
    // Có thể thêm các hành động khác ở đây nếu cần khi không có hash
}


let isScrolling = false;

document.addEventListener('wheel', function (event) {
    if (isScrolling) return;
    if ($('body').data('device-type') === 'mobile') return;

    const $target = $(event.target);
    const $scrollable = $target.closest('.gr_chitiet .tab_content--item');

    if ($scrollable.length) {
        const scrollTop = $scrollable.scrollTop();
        const scrollHeight = $scrollable[0].scrollHeight;
        const height = $scrollable.outerHeight();
        const deltaY = event.deltaY;

        const isAtBottom = scrollTop + height >= scrollHeight - 1;
        const isAtTop = scrollTop <= 0;

        // Nếu còn cuộn được bên trong → cho cuộn tự nhiên
        if (
            (deltaY > 0 && !isAtBottom) ||
            (deltaY < 0 && !isAtTop)
        ) {
            return;
        }

        // Nếu đã chạm đầu/cuối → chặn cuộn cha
        event.preventDefault();
        event.stopPropagation();
        return;
    }

    // Nếu nằm ngoài tab_content--item → xử lý scroll cha
    const activeElement = $('.nav.scrollFrameControl.active');
    let targetElement;

    if (event.deltaY > 0) {
        targetElement = activeElement.nextAll('.nav.scrollFrameControl').first();
    } else {
        targetElement = activeElement.prevAll('.nav.scrollFrameControl').first();
    }

    if (targetElement.length) {
        isScrolling = true;
        targetElement.trigger('click');

        setTimeout(() => {
            isScrolling = false;
        }, 800);
    }
}, { passive: false });
 
    }
});
